// Buttons

export const submit_bt = "Submit";
export const cancel_bt = "Cancel";
export const reset_bt = "Reset";
export const getInTouch = "Get in Touch";
export const exploreSolution = "Explore Solution";
export const joinHands = "Join Hands with us";
export const viewDetails = "View Details";
